export enum UsersLoaderKey {
  GET_USER = 'get-user',
  LIST_USERS = 'list-users',
  SAVE_USER = 'save-user',
  DELETE_USER = 'delete_user',
  ATTACH_USER_GROUP = 'attach-user-group',
  DETACH_USER_GROUP = 'detach-user-group',
  ATTACH_USER_ROLE = 'attach-user-role',
  DETACH_USER_ROLE = 'detach-user-role',
}
